import axios from 'axios';
import { STORE_BASE_URL } from '../BaseURL';
import getHeaders from '../../constants/headers';

export const getAdminPickupJob = (data) => {
  return axios({
    method: 'post',
    url:
      STORE_BASE_URL +
      '/store/api/secure/v1/pickup-job/',
    headers: getHeaders(),
    data: JSON.stringify(data),
  });
};

export const getAdminDeliveryJob = (data) => {
    return axios({
        method: 'post',
        url:
          STORE_BASE_URL +
          '/store/api/secure/v1/delivery-job/',
        headers: getHeaders(),
        data: JSON.stringify(data),
      });
  };